// extracted by mini-css-extract-plugin
export var baseContainer = "styles-module--baseContainer--0e0e2";